import React from "react";
import { useTranslation } from "react-i18next";
import { TagIcon } from "@heroicons/react/24/solid";

import Card from "@components/layout/Card";
import ActionsButton from "@components/shared/DataTable/ActionsButton";
import DataTableRenderer from "@components/shared/DataTable/DataTableRenderer";
import { usePaginationState } from "@components/shared/DataTable/Pagination";
import { ColumnDef } from "@tanstack/react-table";

const OfferTable = () => {
  const { t } = useTranslation();
  const [pagination, setPagination] = usePaginationState();

  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "source",
        header: t("zenith.exchanges.offers.source") as string,
      },
      {
        accessorKey: "volume",
        header: `${t("zenith.exchanges.offers.volume")} ${t(
          "common.volume_unit"
        )}`,
      },
      {
        accessorKey: "price",
        header: `${t("zenith.exchanges.offers.price")} ${t(
          "common.currency"
        )}/${t("common.volume_unit")}`,
      },
      {
        accessorKey: "class",
        header: t("common.water_class") as string,
      },
      {
        id: "actions",
        header: t("common.actions") as string,
        cell: ({ row }) => {
          return (
            <ActionsButton
              menus={[
                {
                  label: t("common.view"),
                  to: `?id=${row.id}`,
                },
              ]}
            />
          );
        },
      },
    ],
    [t]
  );

  return (
    <Card>
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <h3 className="flex gap-3 items-baseline text-primary-2">
            <TagIcon className="w-5 h-5" />
            <span className="text-lg font-semibold">Offers</span>
          </h3>

          <button className="btn-secondary text-sm rounded">
            {t("zenith.exchanges.offers.add_new")}
          </button>
        </div>

        <DataTableRenderer
          columns={columns}
          data={[]}
          name="bids"
          pagination={pagination}
          onPaginationChange={setPagination}
          pageCount={1}
          isLoading={false}
          isFetching={false}
        />
      </div>
    </Card>
  );
};

export default OfferTable;
